export default __webpack_public_path__ + "static/media/scribbleimage1.d9cdb4b2.png";